import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const ACTUAL_ID = "Actual";
export const ACTUAL_COLOR = "#5CBF64";
export const ACTUAL_LEGEND = buildLegend(
  {
    borderColor: ACTUAL_COLOR,
    backgroundColor: ACTUAL_COLOR,
    borderDash: [],
  },
  false,
);

export const PLANNING_TARGET_ID = "Target";
export const PLANNING_TARGET_COLOR = "#7081FF";
export const PLANNING_TARGET_LEGEND = buildLegend(
  {
    borderColor: PLANNING_TARGET_COLOR,
    backgroundColor: PLANNING_TARGET_COLOR,
    borderDash: [],
  },
  false,
);

export const TARGET_RANGE_ID = "NB target range (forecasted period)";
export const TARGET_RANGE_COLOR = "rgba(112, 129, 255, 0.1)";

export const LIVE_FORECAST_ID = "Projected";
export const LIVE_FORECAST_COLOR = "#5CBF64";
export const LIVE_FORECAST_BORDER_DASH = [6, 2];
export const LIVE_FORECAST_LEGEND = buildLegend(
  {
    borderColor: LIVE_FORECAST_COLOR,
    backgroundColor: LIVE_FORECAST_COLOR,
    borderDash: LIVE_FORECAST_BORDER_DASH,
  },
  false,
);
